import React from 'react'
import { X } from 'lucide-react'
import { QuoteDetailPanel } from './QuoteDetailPanel'
import type { EstimateDetail } from '../estimates/types'
import type { EstimateViewAccess } from '@/apis/estimate-view.service'

interface QuoteDetailSheetProps {
  estimate: EstimateDetail | null
  viewAccess: EstimateViewAccess | null
  freeQuota: { granted: number; remaining: number } | null
  loading: boolean
  open: boolean
  onClose: () => void
  onAccept: (estimateId: number) => Promise<void>
  onReject: (estimateId: number) => Promise<void>
  onAccessGranted: () => void
  onSendRequestForProject?: (counselId: number) => void
}

/**
 * 모바일용 상세 시트 (Bottom Sheet 스타일)
 */
export const QuoteDetailSheet: React.FC<QuoteDetailSheetProps> = ({
  estimate,
  viewAccess,
  freeQuota,
  loading,
  open,
  onClose,
  onAccept,
  onReject,
  onAccessGranted,
  onSendRequestForProject,
}) => {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      {/* 백드롭 */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />
      
      {/* 시트 */}
      <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-xl shadow-xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* 헤더 */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">견적서 상세</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg"
            aria-label="닫기"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* 내용 */}
        <div className="flex-1 overflow-y-auto">
          <QuoteDetailPanel
            estimate={estimate}
            viewAccess={viewAccess}
            freeQuota={freeQuota}
            loading={loading}
            onAccept={onAccept}
            onReject={onReject}
            onAccessGranted={onAccessGranted}
            onSendRequestForProject={onSendRequestForProject}
          />
        </div>
      </div>
    </div>
  )
}

